class FeatureDetection {

  supportsPassive: boolean = false;

  constructor() {
    this.detectSupportsPassive();
  }

  private detectSupportsPassive(): void {
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get: () => {
          this.supportsPassive = true;
        }
      });
      window.addEventListener('testPassive', undefined, opts);
      window.removeEventListener('testPassive', undefined, opts);
    } catch (e) {}

  }

}

export const featureDetection = new FeatureDetection();
